<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" @click.self="closeErrorModel">
      <div class="modal">

        <header class="modal-header">
          <slot name="header">
            {{ titre }}
          </slot>
          <button type="button" class="btn-close" @click="closeErrorModel" aria-label="Fermer">
            &times;
          </button>
        </header>

        <section class="modal-body">
          <slot name="body">
            {{ text }}
          </slot>
        </section>

        <footer class="modal-footer">
          <button type="button" class="btn-green" @click="validerErrorModel">
            Accepter
          </button>
          <button type="button" class="btn-red" @click="closeErrorModel">
            Rejeter
          </button>
        </footer>

      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ConfirmationModel",
  props: {
    text: String,
    titre: String,
  },
  methods: {
    closeErrorModel() {
      this.$emit("closeErrorModel");
    },
    validerErrorModel() {
      this.$emit("validerErrorModel");
    },
  },
};
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
}

.modal {
  background: #fff;
  border-radius: 20px;
  max-width: 600px;
  width: 100%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 24px rgba(0,0,0,0.2);
  overflow: hidden;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.modal-header {
  position: relative;
  padding: 1rem 2rem;
  border-bottom: 1px solid #ddd;
  font-weight: 700;
  font-size: 1.25rem;
  color: #0e105c;
  text-align: center;
  background-color: #f9f9f9;
}

.btn-close {
  position: absolute;
  top: 1rem;
  right: 1.5rem;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  color: #ff4d4d;
  cursor: pointer;
  font-weight: bold;
  transition: color 0.2s;
}
.btn-close:hover {
  color: #e60000;
}

.modal-body {
  padding: 2rem;
  font-size: 1.1rem;
  color: #333;
  overflow-y: auto;
  flex-grow: 1;
  line-height: 1.5;
}

.modal-footer {
  padding: 1rem 2rem;
  display: flex;
  justify-content: center;
  gap: 1rem;
  background-color: #f9f9f9;
  border-top: 1px solid #ddd;
}

.modal-footer > button {
  flex: 1;
  padding: 0.75rem 0;
  border-radius: 30px;
  font-weight: 600;
  font-size: 1rem;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
  color: white;
}

.btn-green {
  background-color: #28a745;
}
.btn-green:hover {
  background-color: #218838;
}

.btn-red {
  background-color: #dc3545;
}
.btn-red:hover {
  background-color: #c82333;
}

/* Scrollbar styling for modal body */
.modal-body::-webkit-scrollbar {
  width: 8px;
}
.modal-body::-webkit-scrollbar-thumb {
  background-color: #bbb;
  border-radius: 4px;
}
.modal-body::-webkit-scrollbar-thumb:hover {
  background-color: #999;
}
</style>
